export default "__VITE_ASSET__DHQJjaaE__"